import { useCallback } from "react";
import { useAuthStore } from "../stores/authStore";
import { useActivitiesStore } from "../stores/activitiesStore";
import { useIntegrationsStore } from "../stores/integrationsStore";
import { useChatStore } from "../stores/chatStore";
import { useGlobalChatStore } from "../stores/globalChatStore";
import { useProfileStore } from "../stores/profileStore";

/**
 * Hook that handles complete logout by clearing all user-related stores.
 * This prevents data from one user being visible after logging in as another user.
 */
export function useLogout() {
  const authLogout = useAuthStore((state) => state.logout);
  const resetActivities = useActivitiesStore((state) => state.reset);
  const resetIntegrations = useIntegrationsStore((state) => state.reset);
  const resetChat = useChatStore((state) => state.reset);
  const resetGlobalChat = useGlobalChatStore((state) => state.reset);
  const clearProfile = useProfileStore((state) => state.clearProfile);

  const logout = useCallback(async () => {
    // Call API logout first
    await authLogout();

    // Clear all user-related stores
    resetActivities();
    resetIntegrations();
    resetChat();
    resetGlobalChat();
    clearProfile();
  }, [authLogout, resetActivities, resetIntegrations, resetChat, resetGlobalChat, clearProfile]);

  return { logout };
}
